import { useAccountTypeStructures } from "@features/tickets/shared/hooks/useAccountTypeStructures";
import { INCOME_ACCOUNT_TYPE } from "./incomes.constants";

export function useIncomeStructures() {
  return useAccountTypeStructures(INCOME_ACCOUNT_TYPE);
}
